import { render, staticRenderFns } from "./ConsultaPagos.vue?vue&type=template&id=01871402&scoped=true"
import script from "./ConsultaPagos.vue?vue&type=script&lang=js"
export * from "./ConsultaPagos.vue?vue&type=script&lang=js"
import style0 from "./ConsultaPagos.vue?vue&type=style&index=0&id=01871402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01871402",
  null
  
)

export default component.exports